import React, {FunctionComponent} from 'react';
import './SelectManyModifierGroupEdit.less';
import {ModifierGroup, ModifierGroupId, ModifierGroupSelections} from '../../../helpers/modifier.helper.types';
import {SelectList} from '../select-list/SelectList';
import {SelectListItem} from '../select-list-item/SelectListItem';
import {Checkbox} from '../../elements/checkbox/Checkbox';
import {getModifierComputedName} from '../../../helpers/modifier.helper';

interface SelectManyModifierGroupEditProps {
	modifierGroup: ModifierGroup,
	modifierGroupSelections: ModifierGroupSelections,
	onModifierChange: (modifierGroupSelections: ModifierGroupSelections, changedModifierGroupId: ModifierGroupId) => void,
	onModifierDescriptionClick: (description: string, event: any) => void
}

const MinimumQuantity = 1;

export const SelectManyModifierGroupEdit: FunctionComponent<SelectManyModifierGroupEditProps> = (
	{
		modifierGroup,
		modifierGroupSelections,
		onModifierChange,
		onModifierDescriptionClick,
	}
) => {

	const selectedModifierIds = modifierGroupSelections.map(modifierSelection => modifierSelection.modifierId);

	return (<SelectList>
		{
			modifierGroup.modifiers
				.sort((modifier1, modifier2) => modifier1.soldOut ? 1 : (modifier2.soldOut ? -1 : 0))
				.map(modifier => {
					const id = modifier.modifierId;
					const modifierSelection = modifierGroupSelections
						.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);
					const isSelected = !!modifierSelection;

					return (
						<SelectListItem
							checkboxControl={<Checkbox isChecked={isSelected}/>}
							key={id}
							name={getModifierComputedName(modifier)}
							description={modifier.description}
							onDescriptionClick={onModifierDescriptionClick}
							isSelected={isSelected}
							isDisabled={modifier.soldOut}
							onClick={() => {
								if (selectedModifierIds.includes(id)) {
									onModifierChange(modifierGroupSelections.filter(modifierSelection => modifierSelection.modifierId !== id), modifierGroup.modifierGroupId);
								} else if (modifierGroup.max === 0 || selectedModifierIds.length < modifierGroup.max) {
									onModifierChange(
										[
											...modifierGroupSelections,
											{
												modifierId: id,
												quantity: modifier.defaultQuantity || MinimumQuantity
											}
										],
										modifierGroup.modifierGroupId);
								}

							}}
						/>
					);
				})
		}
	</SelectList>);
};
